<template>
  <div>
    <template>
      <section class="h-screen font-sans bg-cover">
        <form @submit="login()" v-on:submit.prevent="login()" method="POST" action="" class="container mx-auto h-full flex flex-1 justify-center items-center">
          <div class="max-w-sm w-96 m-4 p-10 bg-white rounded shadow-xl ">

            <div class="content">
              <h2 class="mb-4 font-bold text-xl">
                Sign in and boost your community !🚀</h2>

              <input @keypress="cleanError($event.target)" v-model="email" type="email" placeholder="Email" class="mb-4 p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full">

              <input v-model="password" type="password" placeholder="Password" v-bind:class="{ 'mb-1 p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full': msgErrorMail, 'mb-6 p-3 placeholder-gray-400 border border-gray-300 text-gray-700 relative bg-white bg-white rounded text-sm outline-none focus:outline-none focus:shadow-outline w-full': !msgErrorMail }">
              <p class="text-red-500 pb-1">{{ msgErrorMail ? $t('auth.invalid-mail') : ''}}</p>
            </div>
            <footer>
              <common-button
                @click="login"
                :is-loading="isLoading"
                :full-width="true"
                type="primary"
                :submit="true"
                :disabled="isProcessing || !email || !password">{{ $t('auth.signin-action') }}</common-button>
            </footer>

            <div class="mt-1">
              <router-link :to="{ name: 'forgot-password' }" class="text-green-800 font-bold">{{ $t('auth.forgot-password') }}</router-link>
            </div>
          </div>

          <h1 class="font-logo text-4xl ml-10"><span class="text-gray-600">Rocket</span><span class="text-primary">fid</span></h1>
        </form>
      </section>
    </template>
  </div>
</template>

<script>
export default {

  name: 'SignIn',

  data () {
    return {
      email: '',
      password: '',
      EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      msgErrorMail: false,
      isLoading: false,
      isProcessing: false,
      errorCode: ''
    }
  },
  methods: {
    cleanError () {
      this.isProcessing = false
      this.msgErrorMail = false
    },
    validateEmail () {
      if (this.EMAIL_REGEX.test(this.email)) {
        this.isProcessing = false
        this.isLoading = false
        this.msgErrorMail = false
      } else {
        this.isProcessing = true
        this.msgErrorMail = true
      }
    },
    async login () {
      this.validateEmail()
      if (!this.msgErrorMail) {
        if (!this.isProcessing && !this.isLoading) {
          this.isProcessing = true
          this.isLoading = true
          await new Promise(resolve => setTimeout(resolve, 600))

          this.$store.dispatch('user/login', {
            email: this.email,
            password: this.password
          }).then(() => {
            this.$router.push({name: 'WorkspaceList'})
            this.isProcessing = false
          }).catch((response) => {
            this.errorCode = response.data.code
            this.$notify.error({
              title: this.$root.$t('api.' + this.errorCode + '.title'),
              message: this.$root.$t('api.' + this.errorCode + '.message')
            })
            this.isProcessing = false
            this.isLoading = false
          })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Auth/SignIn.vue